import AppHeader from "../../layout/AppHeader";
import PostOfficeBox from '../../xpost/views/register/postofficebox/PostOfficeBox.vue';

const PostOfficeBoxRoutes = [
    {
        path: "/cadastro/caixa-postal",
        name: "postofficebox",
        components: {
            header: AppHeader,
            default: PostOfficeBox
        }
    }
]

export default PostOfficeBoxRoutes;
